import React from 'react';
import { motion } from 'framer-motion';
import { Code, BookOpen, Zap } from 'lucide-react';
import { Button } from '../ui/Button';
export function DevelopersHero() {
  return <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50 overflow-hidden" data-id="element-173">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-40" data-id="element-174">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle at 1px 1px, rgb(148 163 184 / 0.15) 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} data-id="element-175" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="max-w-4xl mx-auto text-center" data-id="element-177">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-178">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-6" data-id="element-179">
              <Code className="w-4 h-4" data-id="element-180" />
              Developer Platform
            </div>

            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-181">
              Build with Obseq APIs
            </h1>

            <p className="text-base sm:text-xl text-slate-600 mb-8 sm:mb-10 leading-relaxed" data-id="element-182">
              Powerful APIs for payments, wallets, FX, compliance, and
              liquidity. Production-ready SDKs, comprehensive docs, and sandbox
              environment.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-183">
              <a href="#/docs" className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl" data-id="element-184">
                <BookOpen className="w-5 h-5" data-id="element-185" />
                Open Documentation
              </a>
              <a href="#/docs/guides/getting-started" className="inline-flex items-center gap-2 px-8 py-4 bg-white text-slate-900 text-lg font-semibold rounded-lg hover:bg-slate-50 transition-colors border-2 border-slate-200" data-id="element-186">
                <Zap className="w-5 h-5" data-id="element-187" />
                Quick Start
              </a>
            </div>
          </motion.div>

          {/* Key Features */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-188">
            <div className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm text-center" data-id="element-189">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-4 mx-auto" data-id="element-190">
                <Code className="w-6 h-6" data-id="element-191" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-192">
                RESTful APIs
              </h3>
              <p className="text-sm text-slate-600" data-id="element-193">
                Clean, consistent JSON APIs with comprehensive error handling
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm text-center" data-id="element-194">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center text-green-600 mb-4 mx-auto" data-id="element-195">
                <BookOpen className="w-6 h-6" data-id="element-196" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-197">
                Complete Docs
              </h3>
              <p className="text-sm text-slate-600" data-id="element-198">
                Guides, API reference, and code examples in 8 languages
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm text-center" data-id="element-199">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center text-purple-600 mb-4 mx-auto" data-id="element-200">
                <Zap className="w-6 h-6" data-id="element-201" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-202">
                Sandbox Mode
              </h3>
              <p className="text-sm text-slate-600" data-id="element-203">
                Test with sandbox keys before going live
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}